export default "__VITE_ASSET__EOFVON91__"